import script from "./InvitationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitationCard.vue?vue&type=script&setup=true&lang=js"

import "./InvitationCard.vue?vue&type=style&index=0&id=5a857843&scoped=true&lang=css"

import exportComponent from "/Users/asani/Documents/NODE/Graduation/fe-gradu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a857843"]])

export default __exports__